import { RegistrationFlow } from '@/hooks/use-registration-context/types';
import { getUtcDateForMDY, yearsAgo } from '@/utils/date-time';
import {
    PropAgeGender,
    PropAgeGenderAgeRangeEnum,
    PropAgeGenderGenderEnum,
    PropSourceSourceEnum,
} from '@calm/evexia-analytics';
import { AccountAccount, AccountGender } from '@calm/evexia-web-sdk';

export function ageToAnalyticsAgeRange(
    age: Date | number
): PropAgeGenderAgeRangeEnum {
    if (!age) {
        return 'null';
    }
    const years = typeof age === 'number' ? age : yearsAgo(age);
    if (years < 13) {
        return 'Under 13';
    } else if (years < 18) {
        return '13-17';
    } else if (years < 24) {
        return '18-23';
    } else if (years < 50) {
        return '24-49';
    } else if (years < 65) {
        return '50-64';
    } else {
        return '65+';
    }
}

export function genderToAnalyticsGender(
    gender?: AccountGender
): PropAgeGenderGenderEnum {
    if (!gender) {
        return 'null';
    }
    switch (gender) {
        case AccountGender.Female:
            return PropAgeGenderGenderEnum.Female;
        case AccountGender.Male:
            return PropAgeGenderGenderEnum.Male;
        case AccountGender.Genderqueer:
            return PropAgeGenderGenderEnum.Genderqueer;
        case AccountGender.NonBinary:
            return PropAgeGenderGenderEnum.Nonbinary;
        case AccountGender.TransgenderFemale:
            return PropAgeGenderGenderEnum.TransWoman;
        case AccountGender.TransgenderMale:
            return PropAgeGenderGenderEnum.TransMan;
        case AccountGender.PreferNotToSay:
            return PropAgeGenderGenderEnum.PreferNotToSay;
        case AccountGender.Other:
            return PropAgeGenderGenderEnum.Other;
        default:
            return 'null';
    }
}

export function accountToAgeGenderAnalytics(
    account: AccountAccount
): PropAgeGender {
    return {
        AgeRange: account?.dob
            ? ageToAnalyticsAgeRange(getUtcDateForMDY(account.dob))
            : 'null',
        Gender: genderToAnalyticsGender(account?.gender),
    };
}

export function registrationFlowToAnalyticsSource(
    registrationFlow: RegistrationFlow
): PropSourceSourceEnum | undefined {
    if (
        [
            RegistrationFlow.NewRegistration,
            RegistrationFlow.SkipSponsorship,
            RegistrationFlow.NewInviteeRegistration,
        ].includes(registrationFlow)
    ) {
        return PropSourceSourceEnum.RegistrationFlow;
    } else if (
        // UpgradeSponsorship reuses this generic sponsorship-update source.
        // EVE-14081 is where Buy-Up gets its own dedicated analytics treatment.
        [
            RegistrationFlow.ChangeOfSponsorship,
            RegistrationFlow.ChangeOfInviteeSponsorship,
            RegistrationFlow.ExistingInviteeRegistration,
            RegistrationFlow.ExistingRegistration,
            RegistrationFlow.UpgradeSponsorship,
        ].includes(registrationFlow)
    ) {
        return PropSourceSourceEnum.UpdateSponsorship;
    } else {
        return undefined;
    }
}
